import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TableColType } from '@shared/enums/table.enum';
import { IActivity } from '@shared/interfaces/activity.interface';
import { ICandidate } from '@shared/interfaces/candidate.interface';
import { ITableCol } from '@shared/interfaces/table.col.interface';
import { CandidatesService } from '@shared/services/candidates.service';
import { CommonEnvironmentsService } from '@shared/services/environments.service';
import { LoggerService } from '@shared/services/logger.service';
import { Broadcaster, NgXCable } from '@shared/services/action-cable.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-sidebar-candidate-activities',
    templateUrl: './sidebar.candidate.activities.component.html',
    standalone: false
})
export class SidebarCandidateActivitiesComponent implements OnInit, OnDestroy {
  @Input() public candidate: ICandidate;

  public isLoading = Boolean(true);
  public rows: IActivity[] = [];
  public cols: Partial<ITableCol>[] = [
    {
      headerText: 'TABLES.HEADERS.DATE',
      type: TableColType.Ago,
      selector: 'created_at'
    },
    {
      headerText: 'TABLES.HEADERS.DESCRIPTION',
      type: TableColType.Text,
      selector: 'description'
    }
  ];

  private readonly constructorName: string = String(this.constructor.name);
  private readonly channel = String('CandidatesChannel');
  private _broadcastSubscription: Subscription;

  constructor(
    private readonly _broadcaster: Broadcaster,
    private readonly _candidates: CandidatesService,
    private readonly _commonEnvironments: CommonEnvironmentsService,
    private readonly _logger: LoggerService,
    private readonly _ngcable: NgXCable
  ) {}

  ngOnInit(): void {
    this.getActivities();

    this._ngcable.connect(this._commonEnvironments.ENDPOINTS_SOCKET);
    this._ngcable.create({ channel: this.channel, room: `${this.candidate?.id}/activities` });

    this._broadcastSubscription = this._broadcaster.on(this.channel).subscribe((res: any) => {
      if (res.type === 'candidate_activities_viewed') {
        this.getActivities();
      }
    });
  }

  ngOnDestroy(): void {
    this._broadcastSubscription?.unsubscribe();
    this._ngcable?.unsubscribe();
  }

  public getActivities() {
    const id = this.candidate?.id;
    const url = `GET /candidates/${id}/activity`;
    this._candidates.getCandidateActivities(id).subscribe(
      (res: IActivity[]) => {
        this._logger.info(this.constructorName, url, res);

        this.rows = res;
        this.isLoading = false;
      },
      (err: any) => {
        this._logger.error(this.constructorName, url, err);
        this.isLoading = false;
      }
    );
  }

  public trackByFn(i: IActivity): string {
    return i.id;
  }
}
